import { render } from "./results-tab.global.vue?vue&type=template&id=76ed8ffe"
import script from "./results-tab.global.vue?vue&type=script&lang=js"
export * from "./results-tab.global.vue?vue&type=script&lang=js"

import "./results-tab.global.vue?vue&type=style&index=0&id=76ed8ffe&lang=scss"

import exportComponent from "/builds/grxl/cinematech/jmpt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__